var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
var HelperServiceService = /** @class */ (function () {
    function HelperServiceService() {
    }
    HelperServiceService.prototype.getLatestComment = function (comments) {
        if (comments && comments.length > 0) {
            return comments[comments.length - 1].body;
        }
    };
    HelperServiceService.prototype.compareByProperty = function (property) {
        return function (a, b) {
            if (a[property] > b[property])
                return -1;
            if (a[property] < b[property])
                return 1;
            return 0;
        };
    };
    HelperServiceService.prototype.clone = function (obj) {
        if (obj == null || typeof obj !== "object")
            return obj;
        var copy = Object.assign({}, obj);
        return copy;
    };
    HelperServiceService.prototype.concatenateAndSort = function (history) {
        // let counter = 1;
        var historyAll = [];
        for (var property in history) {
            if (history.hasOwnProperty(property) && Array.isArray(history[property])) {
                historyAll = historyAll.concat(history[property]);
            }
        }
        historyAll.sort(this.compareByProperty("insertionCounter"));
        return historyAll;
    };
    HelperServiceService = __decorate([
        Injectable({
            providedIn: 'root'
        }),
        __metadata("design:paramtypes", [])
    ], HelperServiceService);
    return HelperServiceService;
}());
export { HelperServiceService };
//# sourceMappingURL=helper-service.service.js.map